import { useTracker, useUBL } from '@common/log-manager';

import { getUrl } from '../utils/getUrl';

export const useZpayOptionLog = () => {
  const tracker = useTracker();
  const sendUBL = useUBL();

  const pageviewUBL = (catalog_product_id: string) => {
    tracker.sendImmediately({
      category: 'pageview',
      navigation: 'zpay_option',
      navigation_sub: { page_url: getUrl() },
      data: { catalog_product_id, is_opened: true },
    });
  };

  const addToCartUBL = (
    object_id: string,
    navigation?: string,
    navigation_sub?: Record<string, unknown>,
    data?: Record<string, unknown>,
    funnel_type?: string,
    is_bundle_purchase?: boolean,
    dr_log?: string,
  ) => {
    if (is_bundle_purchase) {
      tracker.sendImmediately({
        category: 'add_to_cart',
        navigation: navigation || 'zpay_option',
        ...(navigation_sub && { navigation_sub }),
        object_type: 'catalog',
        object_id,
        data: {
          ...(data && data),
          ...(dr_log && { server_log: { dr_log } }),
          ...(funnel_type && { funnel_info_type: funnel_type }),
        },
      });
    } else {
      tracker.sendImmediately({
        category: 'add_to_cart',
        navigation: navigation || 'zpay_option',
        object_section: 'bottom_bar',
        object_type: 'catalog',
        object_id,
        data: {
          funnel_info_type: funnel_type,
          action_btn: '장바구니추가',
          ...(dr_log && {
            server_log: {
              dr_log,
            },
          }),
        },
      });
    }
  };

  const checkoutClickUBL = (catalog_product_id: string) => {
    tracker.sendImmediately({
      category: 'click',
      navigation: 'zpay_option',
      object_type: 'button',
      object_id: 'checkout',
      data: { catalog_product_id },
    });
  };

  const checkoutClickPurchaseKakaoUBL = (catalog_product_id: string) =>
    sendUBL({
      category: 'click',
      navigation: 'zpay_option',
      object_type: 'button',
      object_id: 'kakao_checkout',
      data: { catalog_product_id },
    });

  return {
    pageviewUBL,
    addToCartUBL,
    checkoutClickUBL,
    checkoutClickPurchaseKakaoUBL,
  };
};
